// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1RP5b","filesListContainer":"PosDisputesFiles_filesListContainer__oQPbK","filesButton":"PosDisputesFiles_filesButton__3NPXu"};